import { Popover, Tag } from 'antd';
import TruncatedText from '@client/components/ui/TruncatedText';
import { HtmlContent } from '@client/utils/html_content';

const ItemsWithPopover = ({
  items,
  getItemName,
  maxVisible = 1,
  CustomVisibleContent = null,
  CustomPopoverContent = null,
  isNested = false,
}) => {
  if (!items?.length)
    return <span className="text-gray-400 text-xs italic font-light">N/A</span>;

  const uniqueItems = items.filter(
    (item, index, self) => index === self.findIndex((t) => t.id === item.id)
  );

  const visibleItems = uniqueItems.slice(0, maxVisible);
  const hiddenItems = uniqueItems.slice(maxVisible);

  const popoverContent = hiddenItems.length > 0 && (
    <>
      {CustomPopoverContent ? (
        <CustomPopoverContent items={hiddenItems} />
      ) : (
        <div className="flex flex-col max-w-lg">
          {hiddenItems.map((item, index) => (
            <div
              key={index}
              className="px-4 py-3 border-b border-gray-200 last:border-b-0 hover:bg-gray-50 transition-colors duration-150"
            >
              <div className="font-medium text-sm text-gray-900 leading-relaxed">
                <HtmlContent html={getItemName(item)} />
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
  return (
    <div
      className={`flex ${!CustomVisibleContent ? 'items-center' : 'items-start'}  gap-1`}
    >
      <div className="break-words">
        {CustomVisibleContent ? (
          <CustomVisibleContent items={visibleItems} />
        ) : (
          <>
            {visibleItems.map((item, index) => (
              <span key={index}>
                <TruncatedText text={getItemName(item)} maxLength={30} />
                {index < visibleItems.length - 1 && ', '}
              </span>
            ))}
          </>
        )}
      </div>
      {hiddenItems.length > 0 && (
        <Popover
          content={popoverContent}
          title={
            <div className="flex items-center gap-2 text-gray-700 font-medium py-[12px] px-[18px]">
              <span className="w-1.5 h-1.5 bg-green-600 rounded-full"></span>
              {`${hiddenItems.length} élément${hiddenItems.length > 1 ? 's' : ''} supplémentaire${hiddenItems.length > 1 ? 's' : ''}`}
            </div>
          }
          trigger="click"
          styles={{
            body: {
              maxWidth: '500px',
              padding: '0',
              borderRadius: '8px',
            },
            title: {
              borderBottom: '1px solid #e2e8f0',
              padding: '12px 16px !important',
              margin: '0 !important',
              backgroundColor: '#f8fafc',
              borderRadius: '8px 8px 0 0',
              fontSize: '13px',
            },
            root: {
              maxWidth: '500px',
              zIndex: isNested ? 9999 : 1050,
            },
          }}
          getPopupContainer={isNested ? () => document.body : undefined}
          mouseEnterDelay={isNested ? 0 : 0.1}
          mouseLeaveDelay={isNested ? 0.1 : 0.1}
          placement="topLeft"
          arrow={{
            pointAtCenter: true,
          }}
        >
          <span
            className="inline-flex items-center justify-center cursor-pointer text-xs px-2 py-1 bg-gray-50 hover:bg-gray-100 border border-gray-200 hover:border-gray-300 rounded-md text-gray-600 hover:text-gray-700 flex-shrink-0 transition-all duration-150 font-medium shadow-sm hover:shadow"
            style={{
              pointerEvents: 'auto',
              position: 'relative',
              zIndex: isNested ? 10 : 'auto',
            }}
          >
            +{hiddenItems.length}
          </span>
        </Popover>
      )}
    </div>
  );
};

export default ItemsWithPopover;
